import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';
import IncomeAndSalesSkeleton from '@components/Group/Portfolio/Skeleton/IncomeAndSalesSkeleton';

const IncomeAndSales = lazy(
  () => import('@components/Group/Portfolio/IncomeAndSales')
);

/** 조합 관리 > 상세 > 포트폴리오 상세 > 주요거래처 */
const Customer = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense fallback={<IncomeAndSalesSkeleton />}>
          <IncomeAndSales />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default Customer;
